document.addEventListener("DOMContentLoaded", () => {
  // VARIABLES
  const INCH_CONVERSION = 2.54;
  const MAX_SCALE_FACTOR = 1.3;
  const MIN_SCALE_FACTOR = 0.6;
  const INCH_MARGIN = 3;
  const IMAGE_FACTOR = 0.6;
  const DEFAULT_WIDTH_VALUE = 117;
  const DEFAULT_HEIGHT_VALUE = 90;
  const HOST = window.location.origin;

  const scroller = document.querySelector(
    ".main-product-personalizer__content"
  );
  const nextButton = document.getElementById("toggle-button");
  const prevButton = document.getElementById("toggle-back-button");

  // product
  let priceCurrent = 0;
  let productVariantsByColors;

  // dimensions
  const wallInputElements = document.querySelectorAll(
    "#wall-width-bis, #wall-height-bis"
  );
  const wallWidthInput = document.getElementById("wall-width-bis");
  const wallHeightInput = document.getElementById("wall-height-bis");
  wallWidthInput.value = DEFAULT_WIDTH_VALUE;
  wallHeightInput.value = DEFAULT_HEIGHT_VALUE;
  const addMarginInput = document.getElementById("add-margin");
  let wallMargin = INCH_MARGIN;
  let currentScale = 1;
  let oldCropBox;
  let oldCanvas;
  let isRestoreOldBox = false;

  // zoom
  const ratioInput = document.getElementById("ratioInputBis");
  const ratioDisplay = document.getElementById("ratioDisplayBis");
  const ratioOutput = document.getElementById("inputFinalRatio-bis");
  let lastRatioInput = 100;
  let zoomAutoCurrent = 1;

  // colors
  const colorInputElemnets = document.querySelectorAll(".color-swatch-button");

  // extra imgs
  const extraImagesWrapper = document.querySelector(
    ".block-personalizer .images-wrapper"
  );

  // bg extra colors
  const bgExtraColorsWrapper = document.getElementById('bg-extra-colors-container');
  const bgExtraColorsInputElemnets = document.querySelectorAll(".bg-extra-colors-swatch-button");

  // extra colors
  const extraColorsWrapper = document.querySelectorAll(".block-personalizer .extra-colors-container");
  const extraColorsInputElemnets = document.querySelectorAll(".extra-colors-swatch-button");

  const imagesActive = {};
  // supports
  const supportInputs = document.querySelectorAll(".support-input");
  // total
  const totalSizeEl = document.getElementById("total-size");
  const totalSizeSqftEl = document.getElementById("total-size-sqft");
  const totalPriceEl = document.getElementById("total-price");
  const totalQtyEl = document.getElementById("quantity");

  let totalPrice = 0;
  let totalSize = "";
  let totalSizeSqft = 0;
  let totalSizeM2 = 0;
  let quantity = 0;
  // file
  const inputFinalText = document.getElementById("inputFinalText-bis");
  const inputTailleUs = document.getElementById("inputTailleUs-bis");
  const inputTaille = document.getElementById("inputTaille-bis");
  const inputDecalage = document.getElementById("inputDecalage-bis");
  const inputProductId = document.getElementById("inputProductId");
  // preview
  const widthLabel = document.querySelector(".width-label");
  const heightLabel = document.querySelector(".height-label");
  const horizontalArrow = document.querySelector(".arrow-horizontal");
  const verticalArrow = document.querySelector(".arrow-vertical");
  const buttonActiveMarker = document.getElementById("button-active-marker");

  let canvas;
  let ctx;
  let imagesLoaded;
  
  let mainImageLoaded, extraImagesLoaded, imagesVariantColorLoaded, bdExtraColorsLoaded, extraColorsLoaded;
  let previousWidthCm;
  let previousHeightCm;

  let isInputChange = true;

  let cropperInstance;

  const wallDimensions = {
    ratio: {
      widthCm: 600,
      heightCm: 300,
    },
    max: {
      widthCm: { min: 600, max: 780 },
      heightCm: { min: 300, max: 390 },
    },
    min: {
      widthCm: { min: 50, max: 100 },
      heightCm: { min: 50, max: 100 },
    },
  };

  // FUNCTIONS
  function initData() {
    //console.log("initData bis");
    loadCanvasPreview();
    loadImageRenderView();
    initColors();
    initSupports();
    priceCurrent = totalPriceEl.getAttribute("data-price");
    updateRatioDisplay();
    addEventMarkerButton();
    addEventExtaImgChange();
    addEventDimensionChange();
    addEventAddMargin();
    addEventColorsChange();
    addEventZoomChange();
    addEventSupportChange();
    addEventBgExtaColorsChange();
    addEventExtaColorsChange();

  setTimeout(function() {
    var activeBtn = document.querySelector('.color-swatch-button.active');
    if (activeBtn) {
      var colorKey = (activeBtn.getAttribute('data-color-id') || '').toLowerCase().replace(/[\s\-_]/g, '');
      var items = document.querySelectorAll('.block-personalizer .extra-images .item[data-extra-color-key]');
      items.forEach(function(item) {
        var itemKey = item.getAttribute('data-extra-color-key');
        var isVisible = !colorKey || itemKey === colorKey || itemKey === 'all';
        item.style.display = isVisible ? '' : 'none';
      });
    }
  }, 300);
  }
  // total
  function updateTotal(widthInch, heightInch) {
    calculTotalSQFT(widthInch, heightInch);

    totalQtyEl.value = quantity;
    totalPriceEl.textContent = Shopify.formatMoney(totalPrice, "$ {{amount}}");
    totalSizeEl.textContent = totalSize;
    totalSizeSqftEl.textContent = totalSizeSqft;

    updateOutput();
  }

  function calculTotalSQFT(widthInch, heightInch) {
    totalSize = `${widthInch}inch x ${heightInch}inch`;
    totalSizeSqft = Math.floor(
      calculateSquareFeetFromInches(widthInch, heightInch)
    );
    quantity = calculateQuantity(totalSizeSqft);
    totalPrice = quantity * priceCurrent;
  }

  function updateOutput() {
    const cropBoxData = cropperInstance.getCropBoxData();
    const canvasData = cropperInstance.getCanvasData();

    const widthInch = getWidthInchCurrent();
    const heightInch = getHeightInchCurrent();

    const currentWidthCm = parseFloat(widthInch) * INCH_CONVERSION;
    const currentHeightCm = parseFloat(heightInch) * INCH_CONVERSION;

    const left = cropBoxData.left - canvasData.left;
    const top = cropBoxData.top - canvasData.top;

    const start_x_wall = Math.floor(pxToCm(left));
    const start_y_wall = Math.floor(pxToCm(top));

    const previewUrlParams = {
      x1: left,
      x2: left + cropBoxData.width,
      y1: top,
      y2: top + cropBoxData.height,
      width: canvasData.width,
      height: canvasData.height,
      ratio: ratioInput.value,
      imageUrl: imagesActive[0].src,
    };
    const b64_preview_params = window.btoa(JSON.stringify(previewUrlParams));
    const extra_params = document.getElementById("selected_images_list-bis").value;
    inputFinalText.value =
    HOST + "/pages/preview?params=" +
      b64_preview_params + "&extra=" + extra_params;
    inputTailleUs.value = `${widthInch} x ${heightInch} (inch)`;
    inputTaille.value = `${currentWidthCm} x ${currentHeightCm} (cm)`;
    inputDecalage.value = `${start_x_wall} x ${start_y_wall}`;
    ratioOutput.value = ratioInput.value;
  }

  function calculateQuantity(surface) {
    const surfacePerUnit = 1;
    const quantity = Math.ceil(surface / surfacePerUnit);

    return quantity;
  }

  function calculateSquareFeetFromInches(widthInches, heightInches) {
    // Divide dimensions by 12 to convert to feet
    const widthFeet = widthInches / 12;
    const heightFeet = heightInches / 12;

    const squareFeet = widthFeet * heightFeet;

    return squareFeet;
  }

  function calculateSquareMeters(widthCm, heightCm) {
    const widthM = widthCm / 100;
    const heightM = heightCm / 100;
    const surface = widthM * heightM;

    return surface;
  }

  // supports
  function addEventSupportChange() {
    supportInputs.forEach(function (element) {
      element.addEventListener("click", handleSupportChange);
    });
  }

  function removeEventSupportChange() {
    supportInputs.forEach(function (element) {
      element.removeEventListener("click", handleSupportChange);
    });
  }

  function handleSupportChange(e) {
    const productId = e.currentTarget.getAttribute("data-product-id");
    const price = e.currentTarget.getAttribute("data-price");
    supportInputs.forEach(function (element) {
      element.classList.remove("active");
    });
    e.currentTarget.classList.add("active");
    if (inputProductId) {
      inputProductId.value = productId;
      priceCurrent = price;
    }

    const widthInch = getWidthInchCurrent();
    const heightInch = getHeightInchCurrent();
    updateTotal(widthInch, heightInch);
    updateOutput();
  }

  function initSupports() {
    supportInputs.forEach(function (supportInput) {
      const productId = parseInt(supportInput.dataset.productId, 10);
      const productVariant = window.productVariants.find(
        (prodVariant) => prodVariant.id === productId
      );
      supportInput.querySelector("#support-description").textContent =
        productVariant.supportDescription;
      supportInput.querySelector("#support-place").textContent =
        productVariant.supportPlace;
    });
  }

  function updateSupports(colorName) {
    if (!productVariantsByColors) {
      productVariantsByColors = organizeVariants(window.productVariants);
    }
    const productVariant = productVariantsByColors[colorName];
    supportInputs.forEach(function (supportInput) {
      const currentSupportElement = supportInput.querySelector("#support-name");
      const currentSupportName = currentSupportElement.textContent
        .trim()
        .toLowerCase();
      const findedProductVariant = productVariant.supports.find(
        (support) => support.name.trim().toLowerCase() === currentSupportName
      );

      if (supportInput.classList.contains("active")) {
        inputProductId.value = findedProductVariant.id;
      }
      supportInput.dataset.productId = findedProductVariant.id;
      supportInput.querySelector("#support-description").textContent =
        findedProductVariant.desc;
      supportInput.querySelector("#support-place").textContent =
        findedProductVariant.places;
    });
  }

  // dimentions
  function addEventAddMargin() {
    addMarginInput.addEventListener("input", handleAddMarginChange);
  }
  function removeEventRemoveMargin() {
    addMarginInput.removeEventListener("input", handleAddMarginChange);
  }
  function handleAddMarginChange(e) {
    wallMargin = e.target.checked ? INCH_MARGIN : 0;
    handleDimensionChange();
  }

  function addEventDimensionChange() {
    wallInputElements.forEach(function (element) {
      element.addEventListener("input", handleDimensionChange);
    });
  }

  function removeEventDimensionChange() {
    wallInputElements.forEach(function (element) {
      element.removeEventListener("input", handleDimensionChange);
    });
  }

  function handleDimensionChange() {
    isInputChange = true;
    cropperInstance.reset();
    zoomAutoCurrent = 1;
    resetRatio();

    let widthInch = getWidthInchCurrent();
    let heightInch = getHeightInchCurrent();

    let currentWidthCm = parseFloat(widthInch) * INCH_CONVERSION;
    let currentHeightCm = parseFloat(heightInch) * INCH_CONVERSION;
    // console.log('currentWidthCm', currentWidthCm)
    // console.log('currentHeightCm', currentHeightCm)
    if (
      previousWidthCm === currentWidthCm &&
      previousHeightCm === currentHeightCm
    ) {
      return;
    }

    checkMinimumAreaRequirement(currentWidthCm, currentHeightCm);

    const containerData = cropperInstance.getContainerData();
    let canvasData = cropperInstance.getCanvasData();

    const scaleWidth = currentWidthCm / wallDimensions.ratio.widthCm;
    const scaleHeight = currentHeightCm / wallDimensions.ratio.heightCm;

    let boxWidth = cmToPx(currentWidthCm);
    let boxHeight = cmToPx(currentHeightCm);

    currentScale = parseFloat(Math.max(scaleWidth, scaleHeight).toFixed(3));

    if (currentScale < 1) {
      const maxWidthAllowed = containerData.width * 0.7;
      const maxHeightAllowed = containerData.height * 0.7;

      let ratioZoom = Math.min(
        maxWidthAllowed / boxWidth,
        maxHeightAllowed / boxHeight
      );
      
      let baseZoom = canvasData.width / canvasData.naturalWidth;
      const targetZoomLevel = baseZoom * ratioZoom;

      cropperInstance.zoomTo(targetZoomLevel);

      canvasData = cropperInstance.getCanvasData();
      baseZoom = canvasData.width / canvasData.naturalWidth;
      zoomAutoCurrent = baseZoom;

      boxWidth = cmToPx(currentWidthCm);
      boxHeight = cmToPx(currentHeightCm);

    } else {
      const ratioUserZoom = currentScale;
      const maxWidthAllowed = containerData.width * 0.7;
      const maxHeightAllowed = containerData.height * 0.7;

      const widthRatio = boxWidth / maxWidthAllowed;
      const heightRatio = boxHeight / maxHeightAllowed;

      let zoomAdjustmentFactor = 1;

      if (widthRatio > 1 || heightRatio > 1) {
        zoomAdjustmentFactor = 1 / Math.max(widthRatio, heightRatio);
      }

      let ratioZoom = Math.min(
        maxWidthAllowed / boxWidth,
        maxHeightAllowed / boxHeight
      );

      let baseZoom = canvasData.width / canvasData.naturalWidth;
      let targetZoomLevel =
        baseZoom *
        ratioZoom *
        zoomAdjustmentFactor;

      cropperInstance.zoomTo(targetZoomLevel);

      canvasData = cropperInstance.getCanvasData();
      baseZoom = canvasData.width / canvasData.naturalWidth;
      zoomAutoCurrent = baseZoom;

      boxWidth = cmToPx(currentWidthCm);
      boxHeight = cmToPx(currentHeightCm);

      canvasData = cropperInstance.getCanvasData();
      baseZoom = canvasData.width / canvasData.naturalWidth;
      targetZoomLevel = baseZoom * ratioUserZoom;

      cropperInstance.zoomTo(targetZoomLevel);

      lastRatioInput = "" + ratioUserZoom * 100;
      ratioInput.value = lastRatioInput;
      updateRatioDisplay();
    }

    const cropBoxData = cropperInstance.getCropBoxData();
    const newLeftBis = cropBoxData.left + (cropBoxData.width - boxWidth) / 2;
    const newTopBis = cropBoxData.top + (cropBoxData.height - boxHeight) / 2;

    cropperInstance.setCropBoxData({
      left: newLeftBis,
      top: newTopBis,
      width: boxWidth,
      height: boxHeight,
    });

    const clampedMin = clamp(60, 130, Math.ceil(currentScale * 100));
    ratioInput.setAttribute('min', clampedMin.toString());

    save();
    initGuides(widthInch, heightInch);
    updateMarker(widthInch, heightInch);
    updateTotal(widthInch, heightInch);
    updateOutput();

    setTimeout(() => {
      isInputChange = false;
    }, 0);
  }

  function clamp(min, max, value) {
    if (value < min) {
      return min;
    } else if (value > max) {
      return max;
    } else {
      return value;
    }
  }

  function save() {
    if (isRestoreOldBox) {
      return;
    }
    oldCanvas = cropperInstance.getCanvasData();
    oldCropBox = cropperInstance.getCropBoxData();
  }

  function restore() {
    isInputChange = true;
    cropperInstance.setCanvasData(oldCanvas);
    cropperInstance.setCropBoxData(oldCropBox);
    updateOutput();

    setTimeout(() => {
      isInputChange = false;
    }, 0);
  }

  function getWidthInchCurrent() {
    let widthInch = getInputValueOrDefault(wallWidthInput) + wallMargin;
    let currentWidthCm = parseFloat(widthInch) * INCH_CONVERSION;

    if (parseInt(currentWidthCm) > parseInt(wallDimensions.max.widthCm.max)) {
      currentWidthCm = wallDimensions.max.widthCm.max;
      widthInch = (currentWidthCm / INCH_CONVERSION).toFixed(2);
      wallWidthInput.value = widthInch;
    }

    return widthInch;
  }

  function getHeightInchCurrent() {
    let heightInch = getInputValueOrDefault(wallHeightInput) + wallMargin;
    let currentHeightCm = parseFloat(heightInch) * INCH_CONVERSION;

    if (parseInt(currentHeightCm) > parseInt(wallDimensions.max.heightCm.max)) {
      currentHeightCm = wallDimensions.max.heightCm.max;
      heightInch = (currentHeightCm / INCH_CONVERSION).toFixed(2);
      wallHeightInput.value = heightInch;
    }

    return heightInch;
  }

  function checkMinimumAreaRequirement(widthCm, heightCm) {
    if (!widthCm || !heightCm || widthCm * heightCm < 9290) {
      cropperInstance.clear();
      document.getElementById("wall-width-bis").classList.add("warning");
      document.getElementById("wall-height-bis").classList.add("warning");
      document
        .getElementById("personalize-addcart-button-bis")
        .setAttribute("disabled", "disabled");
      document.getElementById("size-min-required").classList.remove("hidden");
      document.getElementById("total-price-wrapper").classList.add("hidden");
      hideMarker();
    } else {
      document
        .getElementById("personalize-addcart-button-bis")
        .removeAttribute("disabled");
      document.getElementById("size-min-required").classList.add("hidden");
      document.getElementById("total-price-wrapper").classList.remove("hidden");
      document.getElementById("wall-width-bis").classList.remove("warning");
      document.getElementById("wall-height-bis").classList.remove("warning");
      cropperInstance.crop();
    }
  }

  // zoom
  function addEventZoomChange() {
    ratioInput.addEventListener("input", () => handleZoomChange());
  }

  function removeEventZoomChange() {
    ratioInput.removeEventListener("input", () => handleZoomChange());
  }

  function handleZoomChange() {
    console.log("handleZoomChange");
    isInputChange = true;
    if (ratioInput.value === lastRatioInput) {
      return;
    }
    const percentage = parseInt(ratioInput.value, 10) / 100;
    const userZoomRatio = Math.min(Math.max(percentage, 0.6), 1.3);

    const canvasData = cropperInstance.getCanvasData();
    const cropBoxData = cropperInstance.getCropBoxData();

    const targetZoomRatio = zoomAutoCurrent * userZoomRatio;
    const targetCanvasWidth = parseFloat(
      (canvasData.naturalWidth * targetZoomRatio).toFixed(1)
    );
    const targetCanvasHeight = parseFloat(
      (canvasData.naturalHeight * targetZoomRatio).toFixed(1)
    );
    const targetCurrentScale = Math.max(
      cropBoxData.width / targetCanvasWidth,
      cropBoxData.height / targetCanvasHeight
    );

    if (targetCurrentScale > 1 && targetCurrentScale > currentScale) {
      ratioInput.value = lastRatioInput;
      return;
    }

    const centerX = cropBoxData.left + cropBoxData.width / 2;
    const centerY = cropBoxData.top + cropBoxData.height / 2;

    cropperInstance.zoomTo(targetZoomRatio, { x: centerX, y: centerY });
    lastRatioInput = ratioInput.value;
    updateRatioDisplay();
    updateOutput();

    setTimeout(() => {
      isInputChange = false;
    }, 0);
  }

  function updateRatioDisplay() {
    ratioDisplay.textContent = ratioInput.value + " %";
  }

  function resetRatio() {
    ratioInput.value = "100";
    lastRatioInput = ratioInput.value;
    updateRatioDisplay();
  }
  // colors
  function addEventColorsChange() {
    colorInputElemnets.forEach(function (element) {
      element.addEventListener("click", handleColorChange);
    });
  }

  function removeEventColorsChange() {
    colorInputElemnets.forEach(function (element) {
      element.removeEventListener("click", handleColorChange);
    });
  }

  function organizeVariants(variants) {
    const organizedData = {};

    variants.forEach((variant) => {
      const [supportName, colorName] = variant.title.split(" / ");

      if (!organizedData[colorName]) {
        organizedData[colorName] = {
          supports: [],
        };
      }

      organizedData[colorName].supports.push({
        id: variant.id,
        name: supportName,
        desc: variant.supportDescription,
        places: variant.supportPlace,
      });
    });

    return organizedData;
  }

  function handleColorChange(e) {
    const colorIndex = parseInt(e.target.getAttribute("data-color-index"));
    const colorName = e.target.getAttribute("data-color-id");

    colorInputElemnets.forEach(function (element) {
      element.classList.remove("active");
    });
    e.target.classList.add("active");
    updateSupports(colorName);
   imagesActive[0] = imagesVariantColorLoaded[colorIndex];
  for (var key in imagesActive) {
    if (key !== '0') delete imagesActive[key];
  }
  document.getElementById('selected_images_list-bis').value = '';
  drawImages();
    isRestoreOldBox = true;
    const dataURL = canvas.toDataURL();
    document.getElementById("canvas-container").classList.add("opacity-0");
    setTimeout(() => cropperInstance.replace(dataURL), 250);
  }

  function initColors() {
    const colors = document.querySelectorAll(".color-swatch-button");
    if(colors && colors.length > 0) {
      const el = colors[0];
      el.classList.add("active");
    }
  }

  // extra imgs
  function addEventExtaImgChange() {
    if (extraImagesWrapper) {
      const childItems = extraImagesWrapper.querySelectorAll(".item");
      childItems.forEach((child) => {
        child.addEventListener("click", handleExtraImgChange);
      });
    }
  }

  function removeEventExtaImgChange() {
    if (extraImagesWrapper) {
      const childItems = extraImagesWrapper.querySelectorAll(".item");
      childItems.forEach((child) => {
        child.removeEventListener("click", handleExtraImgChange);
      });
    }
  }

  function handleExtraImgChange(event) {
    const target = event.target;
    if (target && target.id) {
      const id = target.id;
      const checkIconContainer = document.getElementById(
        `check-icon-container-${id}`
      );
      if (imagesActive[id]) {
        delete imagesActive[id];
        checkIconContainer.classList.add("hidden");
      } else {
        imagesActive[id] = extraImagesLoaded[parseInt(id) - 1];
        checkIconContainer.classList.remove("hidden");
      }
    } else {
      resetExtraImg();
    }

    // update input for the cart
    const extra_images_array = [];
    for (const key in imagesActive) {
      if (key !== "0") {
        const imageCurrent = imagesActive[key];
        const extra = {
          url: imageCurrent.src,
          type: "extra_images",
        };
        extra_images_array.push(extra);
      }
    }
    document.getElementById("selected_images_list-bis").value =
      extra_images_array.length > 0
        ? window.btoa(JSON.stringify(extra_images_array))
        : "";

    drawImages();
    const dataURL = canvas.toDataURL();
    isRestoreOldBox = true;
    document.getElementById("canvas-container").classList.add("opacity-0");
    setTimeout(() => cropperInstance.replace(dataURL), 250);
  }

  function resetExtraImg() {
    const childItems = extraImagesWrapper.querySelectorAll(".item");
    for (let i = 1; i < childItems.length; i++) {
      const checkIconContainer = document.getElementById(
        `check-icon-container-${i}`
      );
      delete imagesActive[i];
      checkIconContainer.classList.add("hidden");
    }
  }

  // Bg Extra Colors
  function addEventBgExtaColorsChange() {
    bgExtraColorsInputElemnets.forEach(function (element) {
      element.addEventListener("click", handleBgExtraColorsChange);
    });
  }

  function removeEventBgExtaColorsChange() {
    bgExtraColorsInputElemnets.forEach(function (element) {
      element.removeEventListener("click", handleBgExtraColorsChange);
    });
  }

  function handleBgExtraColorsChange(e) { 
    const id = parseInt(e.target.getAttribute("data-bg-extra-color-index"));
    bgExtraColorsInputElemnets.forEach(function (element) {
      element.classList.remove("active");
    });
    e.target.classList.add("active");

    if(id === 0) {
      imagesActive[0] = mainImageLoaded;
      document.getElementById("selected_background-bis").value = "";
    } else {
      imagesActive[0] = bdExtraColorsLoaded[id-1];
      document.getElementById("selected_background-bis").value = imagesActive[0].src;
    }

    drawImages();
    isRestoreOldBox = true;
    const dataURL = canvas.toDataURL();
    document.getElementById("canvas-container").classList.add("opacity-0");
    setTimeout(() => cropperInstance.replace(dataURL), 250);
  }
  // extra colors
  function addEventExtaColorsChange() {
    extraColorsInputElemnets.forEach(function (element) {
      element.addEventListener("click", handleExtraColorsChange);
    });
  }

  function removeEventExtaColorsChange() {
    extraColorsInputElemnets.forEach(function (element) {
      element.removeEventListener("click", handleExtraColorsChange);
    });
  }

  function handleExtraColorsChange(e) { 
    const id = parseInt(e.target.getAttribute("data-extra-color-index"));
    const match = e.target.id.match(/extra-color-(\d+)-(\d+)/);
    const containerIndex = parseInt(match[1], 10);
    const elementIndex = parseInt(match[2], 10);
    const regex = new RegExp(`^extra-color-${containerIndex}-\\d+$`);

    extraColorsInputElemnets.forEach(function (element) {
     if (regex.test(element.id)) {
        element.classList.remove("active");
      }
    });
    e.target.classList.add("active");
    
    if(id === 0) {
      imagesActive[0] = imagesLoaded[0];
    } else {
      imagesActive[containerIndex] = extraColorsLoaded[containerIndex-1][elementIndex-1];
    }

    const extra_images_array = [];
    for (const key in imagesActive) {
      if (key !== "0") {
        const imageCurrent = imagesActive[key];
        const extra = {
          url: imageCurrent.src,
          type: "extra_images",
        };
        extra_images_array.push(extra);
      }
    }
    document.getElementById("selected_images_list-bis").value =
      extra_images_array.length > 0
        ? window.btoa(JSON.stringify(extra_images_array))
        : "";


    drawImages();
    isRestoreOldBox = true;
    const dataURL = canvas.toDataURL();
    document.getElementById("canvas-container").classList.add("opacity-0");
    setTimeout(() => cropperInstance.replace(dataURL), 250);
  }
  
  // preview
  function addEventMarkerButton() {
    buttonActiveMarker.addEventListener("click", handleMarkerChange);
  }

  function removeEventMarkerButton() {
    buttonActiveMarker.removeEventListener("click", handleMarkerChange);
  }

  function handleMarkerChange() {
    const containerGuidesEl = document.getElementById("guides-container");
    if (containerGuidesEl.classList.contains("hidden")) {
      containerGuidesEl.classList.remove("hidden");
      const widthInch = getWidthInchCurrent();
      const heightInch = getHeightInchCurrent();
      initGuides(widthInch, heightInch);
      return;
    }
    containerGuidesEl.classList.add("hidden");
  }

  function hideMarker() {
    const containerGuidesEl = document.getElementById("guides-container");
    if (!containerGuidesEl.classList.contains("hidden")) {
      containerGuidesEl.classList.add("hidden");
    }
  }

  function updateMarker(width, height) {
    widthLabel.textContent = `${width} inch`;
    heightLabel.textContent = `${height} inch`;

    const cropBox = cropperInstance.cropBox;
    if (cropBox) {
      const cropBoxRect = cropBox.getBoundingClientRect();
      const containerRect = canvas.parentNode.getBoundingClientRect();
      // labels
      widthLabel.style.left = `${
        cropBoxRect.left + cropBoxRect.width / 2 - containerRect.left
      }px`;
      widthLabel.style.top = `${cropBoxRect.top - containerRect.top - 30}px`;
      heightLabel.style.left = `${
        cropBoxRect.left - containerRect.left - 70
      }px`;
      heightLabel.style.top = `${
        cropBoxRect.top + cropBoxRect.height / 2 - containerRect.top
      }px`;

      // arrows
      horizontalArrow.style.width = `${cropBoxRect.width}px`;
      horizontalArrow.style.left = `${cropBoxRect.left - containerRect.left}px`;
      horizontalArrow.style.top = `${
        cropBoxRect.top - containerRect.top - 10
      }px`;

      verticalArrow.style.height = `${cropBoxRect.height}px`;
      verticalArrow.style.left = `${
        cropBoxRect.left - containerRect.left - 10
      }px`;
      verticalArrow.style.top = `${cropBoxRect.top - containerRect.top}px`;
    }
  }

  function loadCanvasPreview() {
    const canvasContainer = document.getElementById("canvas-container");
    canvas = document.getElementById("canvas");
    ctx = canvas.getContext("2d");

    const containerWidth = canvasContainer.clientWidth;
    const containerHeight = canvasContainer.clientHeight;

    canvas.width = containerWidth;
    canvas.height = containerHeight;
  }

  async function loadImageRenderView() {
    const images = document.querySelectorAll(
      ".Product__SlideItem img[data-original-src]"
    );

    if (images.length > 0) {
      let backgroundImageSource =
        images[images.length - 1].getAttribute("data-original-src");

      const variantColor = getVariantColor();
      let imagesVariantColor = [];
      if (variantColor) {
        const backgroundImageSourceTemp = getBackgroundByVariantColor(
          images,
          variantColor
        );

        if (backgroundImageSourceTemp) {
          backgroundImageSource = backgroundImageSourceTemp;
        }
        const colorNames = Array.from(colorInputElemnets).map((el) =>
          el.getAttribute("data-color-id")
        );

        imagesVariantColor = colorNames
          .map((colorName) => {
            return getBackgroundByVariantColor(images, colorName);
          })
          .filter((selected) => selected !== undefined);
      }

      try {
        mainImageLoaded = await loadImage(backgroundImageSource);
        extraImagesLoaded = await loadAllImages(extraImagesWrapper, ".item-img img");
        imagesVariantColorLoaded = await loadAllImages(imagesVariantColor);
        bdExtraColorsLoaded = await loadAllImages(bgExtraColorsWrapper, ".swatch-button", "data-bg-extra-color-url");
      
        extraColorsLoaded = await Promise.all(Array.from(extraColorsWrapper).map((el, index) =>
            loadAllImages(el, ".swatch-button", "data-extra-color-url")
                .catch(error => {
                    console.error(`Erreur lors du chargement de l'élément ${index}:`, error);
                    return { index, result: null }; // ou une valeur par défaut
                })
        ));
      } catch (error) {
        console.log("error", error);
      }
      imagesActive[0] = mainImageLoaded;

      canvas.width = mainImageLoaded.width * IMAGE_FACTOR;
      canvas.height = mainImageLoaded.height * IMAGE_FACTOR;

      drawImages();
      initializeCropper(canvas, mainImageLoaded);
    }
  }

  function drawImages() {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    for (const key in imagesActive) {
      const imageCurrent = imagesActive[key];
      if (imageCurrent) {
        ctx.drawImage(
          imageCurrent,
          0,
          0,
          imageCurrent.naturalWidth,
          imageCurrent.naturalHeight,
          0,
          0,
          canvas.width,
          canvas.height
        );
      }
    }
  }

  async function loadAllImages(wrapper, querySelector, queryAttribute) {
    let result = [];

    if(wrapper && querySelector) {
      const childImages = getImages(wrapper, querySelector, queryAttribute);
      const imagePromises = childImages.map((src) => {
          if (src) {
            return loadImage(src);
          }
      });

      result = [...imagePromises];
    } else if(wrapper) {
      const imagePromises = wrapper.map((src) => {
        if (src) {
          return loadImage(src);
        }
      });
      result = [...imagePromises];
    }

    return Promise.all(result);
  }

  function getImages(wrapper, querySelector, queryAttribute) {
    let images;

    if(queryAttribute) {
      images = Array.from(
        wrapper.querySelectorAll(querySelector)
      )
      .map((el) => el.getAttribute(queryAttribute))
      .filter((pro) => pro && pro !== undefined);
    } else {
      images = Array.from(
        wrapper.querySelectorAll(querySelector)
      )
      .map((img) => img.alt)
      .filter((pro) => pro && pro !== undefined);
    }

    return images;
  }

  function loadImage(src) {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.src = src;

      img.onload = () => resolve(img);
      img.onerror = () =>
        reject(`Erreur lors du chargement de l'image : ${src}`);
    });
  }

  function getVariantColor() {
    let varianteColor;
    const colors = document.querySelectorAll(".color-swatch-button");
    if(colors && colors.length > 0) {
      return Array.from(colors)[0].dataset.colorId
    }

    return varianteColor;
  }

  function getBackgroundByVariantColor(images, varianteColor) {
    varianteColor = varianteColor.trim().toLowerCase();

    const backgroundImageList = Array.from(images).map((img) =>
      img.getAttribute("data-original-src")
    );

    const selectedImage = backgroundImageList.find((el) => {
      const src = el.trim().toLowerCase();
      return src.indexOf(`__${varianteColor}__`) !== -1;
    });

    return selectedImage;
  }

  function initializeCropper(canvas, img) {
    const options = {
      zoomable: true,
      zoomOnWheel: false,
      zoomOnTouch: false,
      dragMode: "move",
      viewMode: 1,
      movable: true,
      cropBoxMovable: false,
      cropBoxResizable: false,
      toggleDragModeOnDblclick: false,
      guides: false,
      center: false,
      highlight: false,
      background: false,
      crop: function (e) {
        if (isInputChange) return;
        //console.log("crop");
        const widthInch = getWidthInchCurrent();
        const heightInch = getHeightInchCurrent();
        updateMarker(widthInch, heightInch);
        updateOutput();
        save();
      },
      ready: function (e) {
        //console.log("ready");
        document
          .getElementById("canvas-container")
          .classList.remove("opacity-0");
        setWallDimensions(img);
        handleDimensionChange();
        if (isRestoreOldBox) {
          restore();
          isRestoreOldBox = false;
        }
      },
    };

    cropperInstance = new Cropper(canvas, options);
  }

  function destroyCropper() {
    cropperInstance.destroy();
  }

  function setWallDimensions(img) {
    //console.log("setImageDimensions");
    const imgDataSize = img.src.replace(/^.*[\\\/]/, "").split("x");

    wallDimensions.ratio.widthCm = parseInt(imgDataSize[0]);
    wallDimensions.ratio.heightCm = parseInt(imgDataSize[1]);

    wallDimensions.max.widthCm.min = parseInt(imgDataSize[0]);
    wallDimensions.max.heightCm.min = parseInt(imgDataSize[1]);

    wallDimensions.max.widthCm.max =
      wallDimensions.ratio.widthCm * MAX_SCALE_FACTOR;
    wallDimensions.max.heightCm.max =
      wallDimensions.ratio.heightCm * MAX_SCALE_FACTOR;

    wallWidthInput.setAttribute(
      "min",
      Math.ceil(wallDimensions.min.widthCm.min / INCH_CONVERSION)
    );
    wallWidthInput.setAttribute(
      "max",
      Math.floor(wallDimensions.max.widthCm.max / INCH_CONVERSION)
    );
    wallHeightInput.setAttribute(
      "min",
      Math.ceil(wallDimensions.min.heightCm.min / INCH_CONVERSION)
    );
    wallHeightInput.setAttribute(
      "max",
      Math.floor(wallDimensions.max.heightCm.max / INCH_CONVERSION)
    );
  }

  // guides
  function initGuides(widthInch, heightInch) {
    const cropBoxData = cropperInstance.getCropBoxData();
    // container
    const containerGuidesEl = document.getElementById("guides-container");
    containerGuidesEl.style.transform = `translate(${cropBoxData.left}px, ${cropBoxData.top}px)`;
    containerGuidesEl.style.width = `${cropBoxData.width}px`;
    containerGuidesEl.style.height = `${cropBoxData.height}px`;

    // guide horizontale
    const guideHorizontal = document.querySelector(".guide-horizontal");
    const centerX = cropBoxData.width / 2;
    guideHorizontal.style.left = `${centerX}px`;

    // line horizontale
    const guideHorizontalLineEl = document.querySelector(
      ".guide-line-horizontal"
    );
    guideHorizontalLineEl.style.width = `${cropBoxData.height}px`;

    // label horizontal
    const guideHorizontalLabel = document.querySelector(
      ".guide-horizontal .label"
    );
    guideHorizontalLabel.innerText = `${Math.round(widthInch / 2)} inch`;

    // guide vertical
    const guideVertical = document.querySelector(".guide-vertical");
    const centerY = cropBoxData.height / 2;
    guideVertical.style.top = `${centerY}px`;

    // line vertical
    const guideVerticalLineEl = document.querySelector(".guide-line-vertical");
    guideVerticalLineEl.style.width = `${cropBoxData.width}px`;

    // label vertical
    const guideVerticalLabel = document.querySelector(".guide-vertical .label");
    guideVerticalLabel.innerText = `${Math.round(heightInch / 2)} inch`;
  }

  function makeGuideDraggable(guide, axis) {
    let isDragging = false;

    guide.addEventListener("mousedown", function (event) {
      isDragging = true;
      let startPos = axis === "x" ? event.clientX : event.clientY;

      function onMouseMove(moveEvent) {
        if (!isDragging) return;

        let delta =
          (axis === "x" ? moveEvent.clientX : moveEvent.clientY) - startPos;
        let newPos =
          (axis === "x" ? guide.offsetLeft : guide.offsetTop) + delta;

        let selection = document.querySelector(".cropper-crop-box");
        if (!selection) return;

        let min = axis === "x" ? selection.offsetLeft : selection.offsetTop;
        let max =
          axis === "x"
            ? selection.offsetLeft + selection.offsetWidth
            : selection.offsetTop + selection.offsetHeight;

        if (newPos < min) newPos = min;
        if (newPos > max) newPos = max;

        if (axis === "x") {
          guide.style.left = `${newPos}px`;
          const maxWidth = getWidthInchCurrent();
          const newWidthInch = Math.round((newPos / max) * maxWidth);
          const guideHorizontalLabel = document.querySelector(
            ".guide-horizontal .label"
          );
          guideHorizontalLabel.innerText = `${newWidthInch} inch`;
        } else {
          guide.style.top = `${newPos}px`;
          const maxHeight = getHeightInchCurrent();
          const newHeightInch = Math.round(
            maxHeight - (newPos / max) * maxHeight
          );
          const guideVerticalLabel = document.querySelector(
            ".guide-vertical .label"
          );
          guideVerticalLabel.innerText = `${newHeightInch} inch`;
        }

        startPos = axis === "x" ? moveEvent.clientX : moveEvent.clientY;
      }

      function onMouseUp() {
        isDragging = false;
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
      }

      document.addEventListener("mousemove", onMouseMove);
      document.addEventListener("mouseup", onMouseUp);
    });
  }

  makeGuideDraggable(document.getElementById("guide-horizontal"), "x");
  makeGuideDraggable(document.getElementById("guide-vertical"), "y");

  // HELPERS
  function getInputValueOrDefault(inputElement, defaultValue = 0) {
    return parseFloat(inputElement.value) || defaultValue;
  }

  function pxToCm(value) {
    const canvasData = cropperInstance.getCanvasData();
    const pixelToCmWidth = wallDimensions.ratio.widthCm / canvasData.width;
    return value * pixelToCmWidth;
  }

  function cmToPx(value) {
    const canvasData = cropperInstance.getCanvasData();
    const pixelToCmWidth =  canvasData.width / wallDimensions.ratio.widthCm;
    return value * pixelToCmWidth;
  }

  // ACTION BUTTON
  nextButton.addEventListener("click", () => {
    scroller.style.transform = "translateX(-100vw)";
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    initData();
  });

    // UID unique par ajout au panier : empêche la fusion de 2 sur-mesure identiques
  function setUniqueCartId() {
    const form = inputTaille && inputTaille.form;
    if (!form) return;
    let uidInput = form.querySelector('input[name="properties[_uid]"]');
    if (!uidInput) {
      uidInput = document.createElement("input");
      uidInput.type = "hidden";
      uidInput.name = "properties[_uid]";
      form.appendChild(uidInput);
    }
    uidInput.value = Date.now() + "-" + Math.random().toString(36).slice(2, 7);
  }
  setUniqueCartId();
  document.addEventListener("click", (e) => {
    if (e.target.closest("#personalize-addcart-button-bis")) setUniqueCartId();
  }, true);
  if (inputTaille && inputTaille.form) {
    inputTaille.form.addEventListener("submit", setUniqueCartId, true);
  }


  prevButton.addEventListener("click", () => {
    scroller.style.transform = "translateX(0)";
    destroyCropper();
    removeEventDimensionChange();
    removeEventZoomChange();
    removeEventColorsChange();
    removeEventExtaImgChange();
    removeEventSupportChange();
    removeEventMarkerButton();
    removeEventRemoveMargin();
    removeEventBgExtaColorsChange();
    removeEventExtaColorsChange();
  });
});
